// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
require('./_set-collection-from')('Map');



/*****************
 ** WEBPACK FOOTER
 ** ../~/core-js/modules/es7.map.from.js
 ** module id = 2466
 ** module chunks = 3
 **/